import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ProjectVersion} from "./projectVersionDomain";
import {ID} from "../../../core/metamodel/metaConstant";
import {Criterion} from "../criterion/criterionDomain";

@entityConfig()
export class ProjectCriterionVersion extends DomainAncestor {

  @observable versionId: number;
  @observable name: string;
  @observable isDefault: boolean;
  @observable projectVersion : ProjectVersion
  @observable criterion : Criterion
  @observable score : number
  @observable groupResult : number
  @observable totalResult : number

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.versionId;
  }

  public setId(id: ID): void {
    this.versionId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectCriterionVersionDomain.ts